import { Ability, AbilityBuilder } from '@casl/ability'
import { connect } from "react-redux";
import cookie from 'react-cookies'
import store from '../../redux/store'

// Defines how to detect object's type
function subjectName(item) {
  if (!item || typeof item === 'string') {
    return item
  }
  return item.__type
}

const ability = new Ability([], { subjectName })

// Check redux state for ability update
store.subscribe(() => {
  if (store.getState().rolePermissionStore.rolePermissionList.length > 0){
    ability.update(defineRulesFor(cookie.load('userlevel_id')))
  }
})

function defineRulesFor(auth) {
  const { can, rules } = AbilityBuilder.extract()

  // Iterate store and make rules
  store.getState().rolePermissionStore.rolePermissionList.forEach((p, index) => {
    can(p.function_action, p.function_name)
  })

  return rules
}

export default ability


// WEBPACK FOOTER //
// ./src/configurations/casl/ability.js